import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesSuporte {
  ler: boolean;
  criar: boolean;
  atualizar: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `suporte`
 * (`apps/api/src/modules/suporte/suporte.routes.ts`, seed original da
 * migration `004`): `admin` (curinga `*`) e `suporte` têm CRUD completo
 * sobre o próprio recurso. Nenhum outro papel foi seedado
 * (`PRODUCT.md` 4.7 — módulo de Suporte é exclusivo do papel `suporte`).
 */
export function permissoesSuporte(papel: PapelUsuario): PermissoesSuporte {
  if (papel === 'admin' || papel === 'suporte') return { ler: true, criar: true, atualizar: true };
  return { ler: false, criar: false, atualizar: false };
}
